import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ListSelectionComponent } from './list-selection.component';

@NgModule({
    imports: [
        CommonModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
    ],
    exports: [ListSelectionComponent],
    declarations: [ListSelectionComponent],
})
export class ListSelectionModule {}
